import React from "react";
import { Flex } from "antd";
import { resolveBrandIconUrl } from "../utils/brand-icon.util";

export interface CarMakeLabelProps {
  make: string | undefined;
  model?: string | undefined;
  className?: string;
}

export const CarMakeLabel: React.FC<CarMakeLabelProps> = ({
  make,
  model,
  className,
}) => {
  const iconUrl = resolveBrandIconUrl(make);
  const label = [make?.trim(), model?.trim()].filter(Boolean).join(" ");
  if (!label) {
    return null;
  }
  if (!iconUrl) {
    return <span className={className}>{label}</span>;
  }
  return (
    <Flex align="center" gap={8} className={className}>
      <img
        src={iconUrl}
        alt=""
        className="h-6 w-6 shrink-0 object-contain"
      />
      <span>{label}</span>
    </Flex>
  );
};
